import {
  IsUUID,
  IsString,
  IsInt,
  IsEnum,
  IsOptional,
  IsDateString,
  Min,
} from 'class-validator';
import { Type } from 'class-transformer';
import { AttachmentsResponseInterface } from '../../interface/attachments/attachments-response.interface';
import { AttachmentsStatus } from '../../interface/attachments/attachments-response.interface';

export class AttachmentsDto implements AttachmentsResponseInterface {

  @IsUUID()
  id!: string;

  @IsString()
  bucket_name!: string;

  @IsString()
  storage_path!: string;

  @IsString()
  public_url!: string;

  @IsString()
  file_type!: string;

  @Type(() => Number)
  @IsInt()
  @Min(0)
  file_size!: number;

  @IsString()
  file_name!: string;

  @IsEnum(AttachmentsStatus)
  status!: AttachmentsStatus;

  @IsOptional()
  @IsDateString()
  created_at!: string | null;

  @IsOptional()
  @IsDateString()
  updated_at!: string | null;
}